<template>
  <body>
    <div class="main-content-wrapper">
      <div v-if="isResubscribed">
        <div class="content-section">
          <p class="description">Welcome back {{ this.email }},</p>
          <h3 class="main-heading">
            We had a hunch you'd be back. Subscription successfully processed.
            🥳
          </h3>
          <p class="info">You will receive 'All' emails</p>
        </div>
      </div>
      <div v-else-if="isUnsubscribed == false">
        <h1>Unsubscribe</h1>
        <p>
          Unsubscribe <span id="email"></span> from all marketing email
          messages?
        </p>
        <form>
          <label for="fname">Email Address:</label>
          <br />
          <input
            type="text"
            id="fname"
            placeholder="Your email.."
            v-model="email"
          /><br />
          <button class="buttonload" v-if="showLoader">
            <i class="fa fa-spinner fa-spin"></i>Unsubscribing...
          </button>
          <button
            id="unsubscribe_button"
            type="button2"
            class="button"
            @click="unsubscribeNotification"
            v-else-if="showLoader == false"
          >
            Unsubscribe
          </button>
        </form>
      </div>
      <div v-else-if="isUnsubscribed">
        <div class="unsubscribe-section">
          <h3 class="main-heading">You've successfully unsubscribed</h3>
          <p class="description">
            You will no longer receive any emails from us 🙁
          </p>
        </div>
        <div class="line"></div>
        <div class="resubscribe-section">
          <h4 class="secondary-heading">Changed your mind?</h4>
          <button class="buttonload" v-if="showLoader">
            <i class="fa fa-spinner fa-spin"></i>Resubscribing...
          </button>
          <button
            id="unsubscribe_button"
            type="button2"
            class="button"
            @click="resubscribeButtonPressed"
            v-else-if="showLoader == false"
          >
            + Resubscribe
          </button>
        </div>
        <!-- <p>
          You <span id="email"></span> wont be receiving any marketing related
          email messages.
        </p> -->
      </div>
    </div>
  </body>
</template>

<script>
import API from "../../src/modules/api.js";
import $ from "jquery";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      showLoader: false,
      isUnsubscribed: false,
      isResubscribed: false,
      errorMessage: null,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    resubscribeButtonPressed: async function () {
      this.showLoader = true;
      try {
        await API.admin.config.subOrUnSubscribeNotifi(this.email, "1");
      } catch (err) {
        this.showLoader = false;
      } finally {
        this.showLoader = false;
        this.isResubscribed = true;
        this.Validate();
      }
    },
    unsubscribeNotification: async function () {
      if (!this.email.length) {
        alert("Please enter Email");
        return;
      }
      if (!this.validEmail()) {
        alert("Please enter valid email");
        return;
      }
      this.showLoader = true;
      try {
        await API.admin.config.subOrUnSubscribeNotifi(this.email, "0");
      } catch (err) {
        this.showLoader = false;
      } finally {
        this.showLoader = false;
        this.isUnsubscribed = true;
        this.Validate();
      }
    },
    Validate() {
      this.showLoader = false;
      $(".errorMessage").hide();
      $(".user-view").show();
    },
    validEmail() {
      return this.reg.test(this.email);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* body {
  font-family: "Nunito";
  background: #f6f7f8;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  color: #051b2c;
} */
body {
  font-family: "Nunito";
  background: #f8f8fc;
  height: 100vh;
  position: relative;
}

body > .main-content-wrapper {
  width: 548px;
  padding: 30px;
  row-gap: 20px;
  box-sizing: border-box;

  background: #fff;
  border-radius: 8px;
  /* Elevation/Card */
  box-shadow: 0px 0px 6px 0px rgba(30, 41, 59, 0.2);

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin: auto;
  position: relative;
  top: 100px;
}

@media only screen and (max-width: 548px) {
  body > .main-content-wrapper {
    top: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
  }
}
.main-content-wrapper > .content-section {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.container {
  background-color: #ffffff;
  padding: 24px 24px 26px 24px;
  border-radius: 8px;
  max-width: 438px;
  flex-shrink: 0;
  box-shadow: 0px 3px 4px -1px rgba(5, 27, 44, 0.08) 0px 1px 8px -1px
    rgba(5, 27, 44, 0.12);
}
.email {
  font-size: 1rem;
  width: 100%;
  height: 3rem;
  border-radius: 6px;
  border: 0.5px solid #999999;
  padding: 0 1rem;
}

.email::placeholder {
  font-style: italic;
}

.email:focus {
  border: 2px solid #3695d8;
}
.input[type="text"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.button {
  display: flex;
  padding: 12px 24px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #04aa6d;
  color: #ffffff;
  border-radius: 4px;
  border: 0px solid #04aa6d;
  font-size: 18px;
  width: 50%;
  /* box-shadow: 0px 1px 1px 0px rgba(5, 27, 44, 0.16),
    0px 2px 0px 0px rgba(255, 255, 255, 0.05) inset; */
}

.buttonload {
  border-radius: 4px;
  background-color: #04aa6d; /* Green background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 24px; /* Some padding */
  gap: 10px;
  font-size: 18px; /* Set a font-size */
  margin-top: 20px;
  width: 60%;
}

/* Add a right margin to each icon */
.fa {
  margin-left: -12px;
  margin-right: 8px;
}
.line {
  border-top: 1px solid hsl(0, 0%, 87%);
  margin: 10px 0;
  width: 100%;
}
.unsubscribe-section {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.resubscribe-section {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
.secondary-heading {
  color: hsl(215, 16%, 47%);
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0;
}
.primary-btn {
  width: fit-content;
  border-radius: 4px;
  border: none;
  background: #04aa6d;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  display: flex;
  height: 48px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  column-gap: 8px;

  color: #fff;
}
.primary-btn:hover {
  background: hsl(145, 56%, 61%);
}

.primary-btn:disabled {
  background: hsl(251, 94%, 87%);
  cursor: not-allowed;
}

.main-heading {
  color: #334155;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;

  margin: 0;
}

.description {
  color: hsl(215, 16%, 47%);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  margin: 0;
}
.content-section {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
input[type="text"] {
  width: 70%;
  appearance: none;
  border: none;
  outline: none;
  border-bottom: 0.1em solid #2c934b;
  border-radius: 0.1em 0.1em 0 0;
  padding: 0.4em;
  padding-top: 1.1em;
}
</style>
